import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Advantages from "./components/Advantages";
import Process from "./components/Process";
import Testimonials from "./components/Testimonials";
import Booking from "./components/Booking";
import Footer from "./components/Footer";
import FloatingContact from "./components/FloatingContact";

const App = () => {
  return (
    <main className="bg-noir overflow-hidden">
      <Navbar />
      <Hero />
      <Services />
      <Advantages />
      <Process />
      <Testimonials />
      <Booking />
      <Footer />
      <FloatingContact />
    </main>
  );
};

export default App;
